import {Component, Input, OnInit} from '@angular/core';
import {faClock, faFaucet, faThermometerHalf} from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'app-unit',
  templateUrl: './unit.component.html',
  styleUrls: ['./unit.component.css']
})
export class UnitComponent {
  @Input() unit: string = "";

  GetUnitString() {
    switch (this.unit) {
      case 'l/m2':
        return "l/m²";
      case '`C':
        return "°C";
      case  'J/cm2':
        return "J/cm²";

      default:
        return this.unit;
    }
  }
}
